import React, { Component } from 'react'
import './index.scss'

import MoveButton from '../MoveButton'

import AnimationCount from 'react-count-animation'
import Slick from 'react-slick'

import { Trans } from 'react-i18next'
import i18n from '../../../i18n'

class GalleryArea extends Component {
    state = {
        previouslyDragged: false,
    }

    slickRef1
    slickRef2

    slick1ChangeTime = Date.now()
    slick2ChangeTime = Date.now()

    interval
    slickAnimationInterval = () => {
        const now = Date.now()
        if (now - this.slick1ChangeTime >= (1000 + Math.floor(Math.random() * 10000)) && this.slickRef1) {
            this.slickRef1.slickNext()
            this.slick1ChangeTime = now
        }
        if (now - this.slick2ChangeTime >= (1250 + Math.floor(Math.random() * 10000)) && this.slickRef2) {
            this.slickRef2.slickPrev()
            this.slick2ChangeTime = now
        }
    }

    componentDidMount() {
        this.interval = setInterval(this.slickAnimationInterval, 500)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    onBeforeChange = () => this.setState({ previouslyDragged: true })
    onAfterChange = () => this.setState({ previouslyDragged: false })

    render() {
        const { history, allFinishedVideosCount, gallerys } = this.props
        const { previouslyDragged } = this.state

        const settings = {
            start: 0,
            count: allFinishedVideosCount,
            duration: 3000,
            animation: 'up',
            useGroup: true
        }
        const slickSetting = {
            infinite: true,
            speed: 500,
            slidesToShow: 5,
            swipeToSlide: true,
            variableWidth: true
        }

        const array1 = gallerys.slice(0, Math.floor(gallerys.length / 2))
        const array2 = gallerys.slice(Math.floor(gallerys.length / 2) + 1, gallerys.length)

        return (
            <div className='old-gallery-area-root-container'>
                <div className='heading-area'>
                    <div className="title">
                        <Trans
                            i18nKey="web.newhome.gallery.title"
                        >
                            <AnimationCount {...settings} />
                            <span className='count' />
                        </Trans>
                        <img src="https://front.videomonster.com/images-7cuytg20/web/home/gallery-icon.svg" alt="" />
                    </div>
                    <div className="desc">
                        <Trans
                            i18nKey="web.newhome.gallery.desc"
                        >
                            <b />
                        </Trans>
                    </div>
                </div>
                <div className='gallery-area'>
                    <Slick {...slickSetting}
                        ref={ref => this.slickRef1 = ref}
                        beforeChange={this.onBeforeChange}
                        afterChange={this.onAfterChange}
                    >
                        {
                            array1.map(item => (
                                <img
                                    className='gallery-item'
                                    src={item.thumbnailURL}
                                    alt=''
                                    onClick={this.props.handleGalleryThumbnailClicked(item._id, previouslyDragged)}
                                />
                            ))
                        }
                    </Slick>
                    <Slick {...slickSetting}
                        ref={ref => this.slickRef2 = ref}
                        beforeChange={this.onBeforeChange}
                        afterChange={this.onAfterChange}
                    >
                        {
                            array2.map(item => (
                                <img
                                    className='gallery-item'
                                    src={item.thumbnailURL}
                                    alt=''
                                    onClick={this.props.handleGalleryThumbnailClicked(item._id, previouslyDragged)}
                                />
                            ))
                        }
                    </Slick>
                </div>
                <div className='move-gallery-btn'>
                    <MoveButton
                        history={history}
                        label={i18n.t("web.newhome.move.gallery")}
                        movePath={'/gallery'}
                    />
                </div>
            </div>
        )
    }
}

export default GalleryArea